import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LostJunkListService } from './lost-junk-list.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatDialog } from '@angular/material/dialog';
import { DetailsPanelComponent } from '../../shared/details-panel/details-panel.component';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatMonthView } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-lost-junk-list',
  templateUrl: './lost-junk-list.component.html',
  styleUrls: ['./lost-junk-list.component.css']
})
export class LostJunkListComponent implements OnInit {
  @ViewChild('slidingPanel') slidingPanel!: DetailsPanelComponent;
  constructor(private _dateAdapter: DateAdapter<Moment>,public dialog: MatDialog, private toastr: ToastrService, private lostJunkListService: LostJunkListService) { }

  displayedColumns: string[] = ['first_name', 'mobile', 'email', 'current_stage.stage',  'lost_reason', 'lead_from', 'action'];
  ELEMENT_DATA: any[] = [];
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);
  bucketurl = environment.bucketUrl;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  searchInput = new FormControl('');
  isLoading: Subject<boolean> = new Subject<boolean>();
  leadType: any = [];
  leadStage: any = [];
  productCategory: any = [];
  productModel: any = [];
  productVariant: any = [];
  productColor: any = [];
  uniqueReEngaged: any = []
  leadTypeChecked: any = [];
  leadStageChecked: any = [];
  productCategoryChecked: any = [];
  productModelChecked: any = [];
  productVariantChecked: any = [];
  productColorChecked: any = [];
  uniqueReEngagedChecked: any = [];
  sourceList: any = []
  sourceCheked: any = [];
  baseSourceCheked: any = [];
  baseSource: any = []
  subSource: any = [];
  subSourceChecked: any = [];
  followupStartDate: any = null;
  followupEndDate: any = null;
  filterCount: any = 0;
  panelOpenState = false;
  selectedButton: string = 'today';
  startDate: any;
  endDate: any;

  filters: any = [
    { "key": "leadType", "label": "Lead Type" },
    // { "key": "baseSource", "label": "Base Lead Source" },
    { "key": "source", "label": "Lead Source" },
    { "key": "subSource", "label": "Sub Source" },
    { "key": "stage", "label": "Stage" },
    // { "key": "uniqueReEngaged", "label": "Unique/Re-engaged" },
    { "key": "productCategory", "label": "Product Category" },
    { "key": "productModel", "label": "Product Model" },
    { "key": "productVariant", "label": "Product Variant" },
    { "key": "productColor", "label": "Color" },
    { "key": "followUpDate", "label": "Follow up Date" },
    { key: "missedCalls", label: "Missed Calls" },
  ]
  missed:any = [{id:1, name:'Missed'}];
	missedChecked:any = []

  maxDate = new Date(); // Today's date
  masters:any = {}
  ngOnInit() {
     let filterObject:any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.startDate) {
        this.startDate = new Date(filterObject.startDate);
        this.endDate = new Date(filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = filterObject.selectedButton;
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
    if (sessionStorage.getItem('masters')) {
      this.uniqueReEngaged = []
      this.masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
      const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
      if (masters) {
        this.leadType = masters?.leadType ? masters?.leadType : [];
        this.leadStage = masters?.leadStage ? masters?.leadStage : [];
        this.leadStage = this.leadStage.filter((element: any) => element.id == 5 || element.id == 7)
        this.productCategory = masters?.productCategories ? masters?.productCategories : [];
        this.productModel = masters?.productModel ? masters?.productModel : [];
        this.productVariant = masters?.productVariant ? masters?.productVariant : [];
        this.productColor = masters?.productColor ? masters?.productColor : [];
        this.uniqueReEngaged = masters?.leadStatus ? masters?.leadStatus : [];
        this.sourceList = masters?.leadSource ? masters?.leadSource : [];
        this.subSource = masters?.leadSubSource ? masters?.leadSubSource : [];
        this.baseSource = masters?.baseLeadSource ? masters?.baseLeadSource : [];
      }
    }
    this.getList();
  }

  searchLead(event: any) {
    if (this.searchInput.value) {
      // if (this.searchInput.value.length > 3) {
      this.pageNumber = 1;
      this.getList();
      // }
    } else {
      if (event.key == ' ' && this.searchInput.value?.length == 0) {
      } else {
        this.pageNumber = 1;
        this.getList();
      }
    }
  }

  getList() {
    let queryParams: any = 'page=' + this.pageNumber + '&limit=' + this.pageLimit + '&date_from=' + moment(this.startDate).format("YYYY-MM-DD") + '&date_to=' + moment(this.endDate).format("YYYY-MM-DD");

    if (this.leadStageChecked.length > 0) {
      queryParams += '&stage=' + this.leadStageChecked.join(',');
    } else {
      queryParams += '&stage=5,7'
    }

    if (this.sortColumn != '') {
      queryParams += '&sort_by=' + this.sortColumn + '&sort=' + this.sortOrder
    }

    if (this.searchInput.value) {
      queryParams += '&search=' + this.searchInput.value;
    }

    if (this.leadTypeChecked.length > 0) {
      queryParams += '&lead_type=' + this.leadTypeChecked.join(',');
    }

    if (this.productCategoryChecked.length > 0) {
      queryParams += '&product_category=' + this.productCategoryChecked.join(',');
    }

    if (this.productModelChecked.length > 0) {
      queryParams += '&product_model=' + this.productModelChecked.join(',');
    }

    if (this.productVariantChecked.length > 0) {
      queryParams += '&product_variant=' + this.productVariantChecked.join(',');
    }

    if (this.productColorChecked.length > 0) {
      queryParams += '&product_color=' + this.productColorChecked.join(',');
    }

    if (this.uniqueReEngagedChecked.length > 0) {
      queryParams += '&lead_status=' + this.uniqueReEngagedChecked.join(',');
    }

    if (this.followupStartDate != null && this.followupEndDate != null) {
      queryParams += '&followup_start_date=' + moment(this.followupStartDate).format('YYYY-MM-DD');
      queryParams += '&followup_end_date=' + moment(this.followupEndDate).format('YYYY-MM-DD');
    }

    if (this.baseSourceCheked.length > 0) {
      queryParams += '&base_lead_source=' + this.baseSourceCheked.join(',');
    }

    if (this.sourceCheked.length > 0) {
      queryParams += '&lead_source=' + this.sourceCheked.join(',');
    }

    if (this.subSourceChecked.length > 0) {
      queryParams += '&lead_sub_source_id=' + this.subSourceChecked.join(',');
    }

    if (this.missedChecked.length > 0) {
      queryParams += '&missed_call=' + this.missedChecked.join(',');
    }

    // console.log(queryParams);

    // this.isLoading.next(true);
    this.lostJunkListService.getJunkList(queryParams).subscribe((response: any) => {
      if (response && response.body && response.body.responseCode === 200) {
        let responseData = response.body
        this.isLoading.next(false);
        this.ELEMENT_DATA = response.body.data.list || []; // Ensure data is not null
        this.dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        setTimeout(() => {
          this.paginator.length = responseData?.data?.overview?.total
          this.paginator.pageIndex = this.pageNumber - 1
        }, 100)
      } else {
        this.isLoading.next(false);
        this.toastr.error('Failed to fetch data.');
      }
    }, (error: any) => {
      this.isLoading.next(false);
      this.toastr.error('An error occurred.');
    });
  }

  pageNumber: any = 1
  pageLimit: any = 10
  pageHandler(event: any) {
    this.pageLimit = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.getList();
  }

  @ViewChild('sidenav') sidenav!: MatSidenav;
  isSidenavOpened: boolean = false;


  onSidenavToggle(isOpened: boolean) {
    this.isSidenavOpened = isOpened;
  }

  isFilterOpen: boolean = false;
  toggleSidenav() {
    this.isFilterOpen = !this.isFilterOpen
    this.sidenav.toggle();
    this.closeAllExpansionPanels();
  }

  @ViewChildren(MatExpansionPanel) expansionPanels!: QueryList<MatExpansionPanel>;
  closeAllExpansionPanels() {
    this.expansionPanels.forEach(panel => panel.close());
  }

  check(event: any, data: any, key: any) {
		this.updateFilterCount();
    if (key != 'productModel' && key != 'productCategory' && key != 'productVariant' && key != 'baseSource') {
			setTimeout(() => {
				this.pageNumber = 1;
				this.getList();
				this.updateFilterStatus(key);
			}, 100);
		}
	}

  clearAllFilters() {
    // Iterate through each filter group and set all checkboxes to false
    this.leadType.forEach((data: any) => data.checked = false);
    this.productCategory.forEach((data: any) => data.checked = false);
    this.productModel.forEach((data: any) => data.checked = false);
    this.productVariant.forEach((data: any) => data.checked = false);
    this.productColor.forEach((data: any) => data.checked = false);
    this.uniqueReEngaged.forEach((data: any) => data.checked = false);
    this.leadStage.forEach((data: any) => data.checked = false);
    this.baseSource.forEach((data: any) => data.checked = false);
    this.sourceList.forEach((data: any) => data.checked = false);
    this.subSource.forEach((data: any) => data.checked = false);
    this.missed.forEach((data: any) => data.checked = false);
    this.followupEndDate = null;
    this.followupStartDate = null;
    this.isFollowFilterApplied = false;

    this.filters.map((filter: any) => {
      filter.checked = false
    })

    this.updateFilterCount();
    setTimeout(() => {
      this.getList();
    }, 200)
  }


  updateFilterCount() {
    this.leadTypeChecked = this.leadType
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.leadStageChecked = this.leadStage
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.productCategoryChecked = this.productCategory
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.productModelChecked = this.productModel
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.productVariantChecked = this.productVariant
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.productColorChecked = this.productColor
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.uniqueReEngagedChecked = this.uniqueReEngaged
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.subSourceChecked = this.subSource
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

      this.baseSourceCheked = this.baseSource
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.sourceCheked = this.sourceList
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

      this.missedChecked = this.missed
      .filter((data: any) => data.checked === true)
      .map((data: any) => data.id);

    this.filterCount = this.leadType.filter((data: any) => data.checked).length +
      this.leadStage.filter((data: any) => data.checked).length +
      this.productCategory.filter((data: any) => data.checked).length +
      this.productModel.filter((data: any) => data.checked).length +
      this.productVariant.filter((data: any) => data.checked).length +
      this.productColor.filter((data: any) => data.checked).length +
      this.baseSource.filter((data: any) => data.checked).length +
      this.sourceList.filter((data: any) => data.checked).length +
      this.subSource.filter((data: any) => data.checked).length +
      this.missed.filter((data: any) => data.checked).length +
      this.uniqueReEngaged.filter((data: any) => data.checked).length +
      (this.isFollowFilterApplied ? 1 : 0)
  }

  @ViewChild('dateRangePicker') dateRangePickerTemplate!: TemplateRef<any>;
  @ViewChild('cancelButton') cancelButton!: ElementRef;
  @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;

  openDateRangePicker() {
     const dialogRef:any = this.dialog.open(this.dateRangePickerTemplate, { panelClass: 'modal-picker-class' });
     dialogRef.afterOpened().subscribe(() => {
    if (this.startCalendar) {
      const selectMonth = new Date(this.startDate);
      this.startCalendar.activeDate = selectMonth;
    }
  });
    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.nativeElement.focus();
      }
    }, 300);
  }

  selectToday() {
    const today = new Date();
    this.startDate = today;
    this.endDate = today;
    this.selectedButton = 'today';
    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date();
		selectMonth.setMonth(selectMonth.getMonth());
		if (this.startCalendar) {
			this.startCalendar.activeDate = selectMonth;
		}
  }

  minDate:any = ''
  // selectLast7Days() {
  //   const today = new Date();
  //   this.startDate = new Date(today.setDate(today.getDate() - 7));
  //   this.endDate = new Date();
  //   this.selectedButton = 'last7';
  //   this.dateRange = new DateRange(this.startDate, this.endDate);
  //   const selectMonth = new Date();
	// 	selectMonth.setMonth(selectMonth.getMonth());
	// 	if (this.startCalendar) {
	// 		this.startCalendar.activeDate = selectMonth;
	// 	}
  //   this.minDate = this.startDate
  // }

  // selectLast15Days() {
  //   const today = new Date();
  //   this.startDate = new Date(today.setDate(today.getDate() - 15));
  //   this.endDate = new Date();
  //   this.selectedButton = 'last15';
  //   this.dateRange = new DateRange(this.startDate, this.endDate);
  //   const selectMonth = new Date();
	// 	selectMonth.setMonth(selectMonth.getMonth());
	// 	if (this.startCalendar) {
	// 		this.startCalendar.activeDate = selectMonth;
	// 	}
  // }

  selectLastDays(days: number, buttonLabel: string) {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    
    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - days); // 7 days excluding today
    
    this.endDate = yesterday; 
    this.selectedButton = buttonLabel;
    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date(this.startDate);
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }
  
  selectLast7Days() {
    this.selectLastDays(6, 'last7');
  }
  
  selectLast15Days() {
    this.selectLastDays(14, 'last15');
  }
  
  selectLast30Days() {
    this.selectLastDays(29, 'last30');
  }

  selectThisMonth() {
    this.selectedButton = 'thisMonth';
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = startOfMonth;
    this.endDate = today;
    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date();
		selectMonth.setMonth(selectMonth.getMonth());
		if (this.startCalendar) {
			this.startCalendar.activeDate = selectMonth;
		}
  }

  selectCustom() {
    this.selectedButton = 'custom';
    this.startDate = null;
    this.endDate = null;
    this.dateRange = new DateRange(this.startDate, this.endDate);
  }

  onStartDateChange(event: Date) {
    this.startDate = event;
  }

  onEndDateChange(event: Date) {
    this.endDate = event;
  }

  closeDialog() {
    if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
      this.toastr.error("The end date should be greater than or equal to the start date!")
    } else {
      this.selectThisMonth();
      setTimeout(() => {
        this.applyDateRange();
      }, 100)
      this.dialog.closeAll();
    }
  }

  applyDateRange() {
    // Logic to apply the date range
    if (this.startDate == null || this.endDate == null) {
      this.toastr.error("Please select a date range!");
    } else {
      if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
        this.toastr.error("The end date should be greater than or equal to the start date!")
      } else {
        let filterObject: any = {}
        if (sessionStorage.getItem('filterObject')) {
          filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        }
        filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
        filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
        filterObject.selectedButton = this.selectedButton;
        sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
        this.getList();
        this.dialog.closeAll();
      }
    }
  }

  isFollowFilterApplied: boolean = false;
  applyFollowupDate() {
    if (this.followupStartDate == null && this.followupEndDate == null) {
      this.toastr.error("The Start date & End date cannot be empty!")
    } else if (this.followupStartDate == null) {
      this.toastr.error("The Start date cannot be empty!")
    } else if (this.followupEndDate == null) {
      this.toastr.error("The End date cannot be empty!")
    } else if (moment(this.followupStartDate).format('YYYY-MM-DD') > moment(this.followupEndDate).format('YYYY-MM-DD')) {
      this.toastr.error("The end date should be greater than or equal to the start date!")
    } else {
      this.getList();
      this.isFollowFilterApplied = true;
      this.updateFilterStatus('followUpDate');
      this.updateFilterCount();
    }
  }

  clearFollowUpDate() {
    this.isFollowFilterApplied = false;
    this.followupEndDate = null;
    this.followupStartDate = null;
    this.getList();
    this.updateFilterCount();
    this.updateFilterStatus('followUpDate');
  }

  sortColumn: any = ''
  sortOrder: any = ''
  sortChange(event: any) {
    if (event.direction != '') {
      this.sortColumn = event.active;
      this.sortOrder = event.direction == 'desc' ? -1 : 1;
      this.getList();
    } else {
      this.sortColumn = '';
      this.sortOrder = '';
      this.getList();
    }
  }

  restrictFirstLetterSpace(event: any) {
    if (event.target.value.length == 0) {
      if (event.code === 'Space') {
        event.preventDefault();
      }
    }
  }
  onPanelToggle(event: any) {
    if (!event) {
      this.getList();
    }
  }

  updateFilterStatus(filterKey: string): void {
    const filter: any = this.filters.find((f: any) => f.key == filterKey);
    if (filter) {
      filter.checked = this.isAnyCheckboxChecked(filterKey);
    }
  }

  isAnyCheckboxChecked(filterKey: string): boolean {
    // Check the respective data arrays based on the filterKey
    if (filterKey === 'leadType') return this.leadType.some((data: any) => data.checked);
    if (filterKey === 'stage') return this.leadStage.some((data: any) => data.checked);
    if (filterKey === 'productCategory') return this.productCategory.some((data: any) => data.checked);
    if (filterKey === 'productModel') return this.productModel.some((data: any) => data.checked);
    if (filterKey === 'productVariant') return this.productVariant.some((data: any) => data.checked);
    if (filterKey === 'productColor') return this.productColor.some((data: any) => data.checked);
    if (filterKey === 'uniqueReEngaged') return this.uniqueReEngaged.some((data: any) => data.checked);
    if (filterKey === 'baseSource') return this.baseSource.some((data: any) => data.checked);
    if (filterKey === 'source') return this.sourceList.some((data: any) => data.checked);
    if (filterKey === 'subSource') return this.subSource.some((data: any) => data.checked);
    if (filterKey === 'missedCalls') return this.missed.some((data: any) => data.checked);
    if (filterKey === 'followUpDate') return this.isFollowFilterApplied;
    return false;
  }

  
	onCategorySelect() {
		setTimeout(() => {
			if (this.masters?.productModel.length > 0) {
				this.masters.productModel.forEach((model: any) => {
					if (this.productCategoryChecked.includes(model.category_id)) {
						// Do nothing or retain current state if category_id is present
					} else {
						// If category_id is not present in productCategoryChecked, set checked to false
						model.checked = false;
					}
				});
				// Now, filter productModel to only include models with category_id in productCategoryChecked
				this.productModel = this.masters.productModel.filter((model: any) =>
					this.productCategoryChecked.includes(model.category_id)
				);
				setTimeout(() => {
          if(this.productModel.length == 0){
            this.productModel = [...this.masters.productModel]
          }
					this.productModelChecked = this.productModel
						.filter((data: any) => data.checked === true)
						.map((data: any) => data.id);
					this.updateFilterCount();
					this.updateFilterStatus('productCategory');
					this.onModelSelect();
				}, 100)
			}
		}, 300)
	}

	onModelSelect() {
		setTimeout(() => {
			if (this.masters?.productVariant.length > 0) {
				this.masters.productVariant.forEach((model: any) => {
					if (this.productModelChecked.includes(model.model_id)) {
						// Do nothing or retain current state if model id is present
					} else {
						model.checked = false;
					}
				});
				this.productVariant = this.masters.productVariant.filter((model: any) =>
					this.productModelChecked.includes(model.model_id)
				);
				setTimeout(() => {
          if(this.productVariant.length == 0){
            this.productVariant = [...this.masters.productVariant]
          }
					this.productVariantChecked = this.productVariant
						.filter((data: any) => data.checked === true)
						.map((data: any) => data.id);
					this.pageNumber = 1;
					// this.getList();
					this.updateFilterCount();
					this.updateFilterStatus('productModel');
					this.updateFilterStatus('productVariant');
					this.onVariantSelect();
				}, 100)
			}
		}, 300)
	}

	onVariantSelect() {
		// Get the selected variants
		let checkedVariants = this.productVariant.filter((variant: any) => variant.checked);
	
		// If there are no checked variants, reset the colors
		if (checkedVariants.length === 0) {
			this.resetColors();
			return;
		}
	
		// Extract color IDs from selected variants, assuming color_id is a comma-separated string
		let colorIds = new Set<string>();
		checkedVariants.forEach((variant: any) => {
			variant.color_id[0].split(',').forEach((id: string) => colorIds.add(id.trim()));
		});
	
		// Filter productColor based on color IDs
		this.productColor = this.masters.productColor.filter((color: any) => colorIds.has(color.id.toString()));
		
		// Ensure no colors are initially checked
		this.productColor.forEach((color: any) => {
			color.checked = false;
		});
	
		// Additional steps as needed
		this.productColorChecked = this.productColor
			.filter((data: any) => data.checked === true)
			.map((data: any) => data.id);
	
		this.pageNumber = 1;
		this.getList();
		this.updateFilterCount();
		this.updateFilterStatus('productVariant');
		this.updateFilterStatus('productColor');
	}
	
	// Method to reset color checkboxes and list
	resetColors() {
		// Reset productColor to include all possible colors
		this.productColor = [...this.masters.productColor];
	
		// Uncheck all color checkboxes
		this.productColor.forEach((color: any) => {
			color.checked = false;
		});
	
		// Clear the checked color IDs
		this.productColorChecked = [];
	
		// Ensure the UI is updated accordingly
		this.pageNumber = 1;
		this.getList();
		this.updateFilterCount();
		this.updateFilterStatus('productColor');
	}

  
	onBaseSelect() {
		setTimeout(() => {
			if (this.masters?.leadSource.length > 0) {
				this.masters.leadSource.forEach((model: any) => {
					if (this.baseSourceCheked.includes(model.base_lead_source_id)) {
						// Do nothing or retain current state if category_id is present
					} else {
						// If category_id is not present in productCategoryChecked, set checked to false
						model.checked = false;
					}
				});
				// Now, filter productModel to only include models with category_id in productCategoryChecked
				this.sourceList = this.masters.leadSource.filter((model: any) =>
					this.baseSourceCheked.includes(model.base_lead_source_id)
				);
				setTimeout(() => {
					if(this.sourceList.length == 0){
						this.sourceList = [...this.masters.leadSource]
					}
					this.sourceCheked = this.sourceList
						.filter((data: any) => data.checked === true)
						.map((data: any) => data.id);
					this.updateFilterCount();
					this.updateFilterStatus('baseSource');
					this.onSourceSelect();
				}, 100)
			}
		}, 300)
	}

  defaultSubSource:any = []
  onSourceSelect() {
		setTimeout(() => {
			if (this.masters?.leadSubSource.length > 0) {
				this.masters.leadSubSource.forEach((model: any) => {
					if (this.sourceCheked.includes(model.lead_source_id)) {
						// Do nothing or retain current state if category_id is present
					} else {
						// If category_id is not present in productCategoryChecked, set checked to false
						model.checked = false;
					}
				});
				// Now, filter productModel to only include models with category_id in productCategoryChecked
				let sourceIds:any = this.sourceList.map((item:any)=> item.id)
				this.subSource = this.masters.leadSubSource.filter((model: any) =>
					sourceIds.includes(model.lead_source_id)
				);
        this.defaultSubSource = [...this.subSource]
				setTimeout(() => {
					// if(this.subSource.length == 0 && this.sourceCheked.length == 0){
					// 	this.subSource = [...this.masters.leadSubSource]
					// }
					this.subSourceChecked = this.subSource
						.filter((data: any) => data.checked === true)
						.map((data: any) => data.id);
					this.updateFilterCount();
					this.updateFilterStatus('source');
					this.updateFilterStatus('subSource');
					this.pageNumber = 1;
					this.getList();
				}, 100)
			}
		}, 300)
	}

  
  onSourceSelectManually(){
    setTimeout(() => {
			if (this.masters?.leadSubSource.length > 0) {
				this.masters.leadSubSource.forEach((model: any) => {
					if (this.sourceCheked.includes(model.lead_source_id)) {
						// Do nothing or retain current state if category_id is present
					} else {
						// If category_id is not present in productCategoryChecked, set checked to false
						model.checked = false;
					}
				});
				// Now, filter productModel to only include models with category_id in productCategoryChecked
				this.subSource = this.masters.leadSubSource.filter((model: any) =>
					this.sourceCheked.includes(model.lead_source_id)
				);
				setTimeout(() => {
					if(this.subSource.length == 0 && this.sourceCheked.length == 0){
						this.subSource = [...this.defaultSubSource]
					}
					this.subSourceChecked = this.subSource
						.filter((data: any) => data.checked === true)
						.map((data: any) => data.id);
					this.updateFilterCount();
					this.updateFilterStatus('source');
          this.updateFilterStatus('subSource');
					this.pageNumber = 1;
					//  this.getList();
				}, 20)
			}
		}, 50)
  }

  	// Private
	_startDate: any | null = null;
	_endDate: any | null = null;

	// Set the range
	range: { start: Date | null; end: Date | null } = {
		start: moment().endOf('month').subtract(1, 'week').toDate(),
		end: moment().endOf('month').add(1, 'week').toDate()
	};

	// DateRange instance using range
	dateRange = new DateRange(this.range.start, this.range.end);

	selectedChange(date: any): void {
		if (!this._startDate) {
			this._startDate = date;
		} else if (
			!this._endDate &&
			this._dateAdapter.compareDate(date, this._startDate) >= 0
		) {
			this._endDate = date;
		} else {
			this._startDate = date;
			this._endDate = null;
		}
		this.dateRange = new DateRange(this._startDate, this._endDate);
		this.startDate = this._startDate;
		this.endDate = this._endDate;
		console.log(this.startDate, this.endDate)
	}

   reset(){
       let filterObject:any = {}
      if (sessionStorage.getItem('filterObject')) {
        filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        if (filterObject.startDate) {
          this.startDate = new Date(filterObject.startDate);
          this.endDate = new Date(filterObject.endDate);
          this.dateRange = new DateRange(this.startDate, this.endDate);
          this.selectedButton = filterObject.selectedButton;
        } else {
          this.selectThisMonth();
        }
      }else {
        this.selectThisMonth();
      }
    }
}
